import { useEffect, useState } from 'react';
import { getCatalogAvatarMap, getCatalogIconMap } from '../../services/agentService';

/**
 * The admin-set default avatar images, keyed by catalog `profile_id`. Fetched once per session
 * (cached in the service). The in-chat avatar renderer uses this as the fallback below a
 * per-chat user-generated avatar, so applying the default set via /admin shows up in chat.
 */
export function useCatalogAvatars(): Record<string, string> {
  const [map, setMap] = useState<Record<string, string>>({});
  useEffect(() => {
    let alive = true;
    getCatalogAvatarMap().then((m) => { if (alive) setMap(m); });
    return () => { alive = false; };
  }, []);
  return map;
}

/**
 * The catalog's per-agent Lucide icon, keyed by agent id. The companion to `useCatalogAvatars`: an agent
 * usually has no uploaded photo, and its icon is what distinguishes it from every other agent on a seat.
 */
export function useCatalogIcons(): Record<string, string> {
  const [map, setMap] = useState<Record<string, string>>({});
  useEffect(() => {
    let alive = true;
    getCatalogIconMap().then((m) => { if (alive) setMap(m); });
    return () => { alive = false; };
  }, []);
  return map;
}
